<header class="main-header bg-white">
  <div class="top-strip bg-primary">
    <div class="container">
      <div class="d-flex justify-content-md-between align-items-center justify-content-center flex-column flex-md-row">
        <div class="d-flex align-items-center">
          <div class="location-dropdown cursor-pointer d-flex me-md-4 my-4 my-md-0" (click)="onSelect()">
            <input type="text" [(ngModel)]="selectedOutpost" class="form-control input-class cursor-pointer"
              name="txtOutpost" id="txtOutpost" placeholder="Select Center" />
            <div class="icon-box ms-3">
              <i class="fa-solid fa-angle-down"></i>
            </div>
          </div>
          <ul class="d-lg-flex d-none hours-list">
            <li>
              <span>Mon - FRI</span>
              <strong class="d-block">6 AM - 8 PM</strong>
            </li>
            <li>
              <span>SATURDAY</span>
              <strong class="d-block">6 AM - 6 PM</strong>
            </li>
            <li>
              <span>SUNDAY</span>
              <strong class="d-block">9 AM - 6 PM</strong>
            </li>
          </ul>
        </div>
        <div class="d-flex align-items-center">

          @if (switchDetails.switch_back != '') {
          <a (click)="backToDashboard()"
            class="link text-success me-3 d-xl-flex d-none align-items-center small cursor-pointer">
            <i class="fa-solid fa-chevron-left me-1"></i>
            Back to Admin</a>
          }

          <ul class="account-list d-flex align-items-center" [ngClass]="{ 'no-login': !loginService.userData.length }">
            @if(loginService.userData.length){
            <li class="d-md-block d-none">
              <div ngbDropdown class="position-relative">
                <button type="button" class="d-flex btn profile-btn align-items-center" id="dropdownBasic1"
                  ngbDropdownToggle>
                  <span class="profile-img me-2 rounded-circle overflow-hidden" [ngClass]="{
                      'with-text': !loginService.userData[0].avatar
                    }">
                    @if (loginService.userData[0].avatar) {
                    <ngx-avatars src="{{imgPrefixLink}}/user/avatar/{{ loginService.userData[0].avatar }}"
                      (click)="openDropdownMenu()">
                    </ngx-avatars>
                    }@else {
                    <ngx-avatars bgColor="{{ avatar_bg_color }}" fgColor="{{ avatar_fg_color }}"
                      name="{{ loginService.userData[0].full_name }}" textSizeRatio="2" (click)="openDropdownMenu()">
                    </ngx-avatars>
                    }
                  </span>
                  <span>{{
                    loginService.userData[0].full_name | titlecase
                    }}</span>
                  <i class="fa-solid fa-angle-down ms-2"></i>
                </button>
                <div ngbDropdownMenu aria-labelledby="dropdownBasic1" class="dropdown-menu-end">
                  <ul>
                    @for (item of menuItems; track $index) {
                    <li>
                      <button ngbDropdownItem (click)="goToPage(item?.route)" class="d-flex align-items-center">
                        <div class="img-box d-flex align-items-center justify-content-center rounded-circle me-3">
                          <img [src]="item?.icon" />
                        </div>

                        <span>
                          {{ item?.title }}
                        </span>
                        <i class="fa-solid fa-arrow-right"></i>
                      </button>
                    </li>
                    } @if (switchDetails.switch_back == '' && userData[0]?.type !=
                    'backend') {
                    <li>
                      <button (click)="logout()" ngbDropdownItem class="d-flex align-items-center">
                        <div class="img-box d-flex align-items-center justify-content-center rounded-circle me-3">
                          <img [src]="'assets/images/icon/logout.svg'" />
                        </div>
                        <span class="menu-text">Logout</span>
                        <i class="fa-solid fa-arrow-right"></i>
                      </button>
                    </li>
                    } @if (switchDetails.switch_back != '') {
                    <li>
                      <button (click)="backToDashboard()" ngbDropdownItem class="d-flex align-items-center">
                        <div class="img-box d-flex align-items-center justify-content-center rounded-circle me-3">
                          <img [src]="'assets/images/icon/back-admin.svg'" />
                        </div>
                        <span class="menu-text">Back to Admin</span>
                        <i class="fa-solid fa-arrow-right"></i>
                      </button>
                    </li>
                    }
                  </ul>
                </div>
              </div>
            </li>

            }@else {

            <li class="me-3">
              @if(router.url == '/login' || router.url == '/registration'){
              <a class="cursor-pointer" [routerLink]="['/registration']">Sign Up</a>
              }@else {
              <a class="cursor-pointer" (click)="loginService.openLoginModal('signup')">Sign Up</a>
              }
            </li>
            <li class="ms-3">
              @if(router.url == '/login' || router.url == '/registration'){
              <a class="cursor-pointer" [routerLink]="['/login']">Login</a>
              }@else {
              <a class="cursor-pointer" (click)="loginService.openLoginModal('login')">Login</a>
              }
            </li>
            }
          </ul>
        </div>
      </div>
    </div>
  </div>
  <div class="bottom-strip bg-white py-3 py-lg-0"
    [ngClass]="{ 'sticky-header': (isSticky$ | async) === true,'not-logged-in':!loginService.userData.length }">
    <div class="container">
      <div class="row">
        <div class="col-12">
          <div class="inner-box d-flex align-items-center justify-content-between">
            <div class="d-flex align-items-center">
              <div class="mobile-menu d-md-inline-flex d-lg-none me-2" [ngClass]="{ 'mobile-menu-open': isMenuOpen }">
                <!-- Menu Toggle btn-->

                <div class="hamburger" id="menu-btn" (click)="clickOnMenuIcon();">
                  <span class="line"></span>
                  <span class="line"></span>
                  <span class="line"></span>
                </div>
                <!-- Responsive Menu Structure-->
                <!--Note: declare the Menu style in the data-menu-style="horizontal" (options: horizontal, vertical, accordion) -->
              </div>
              <div class="brand cursor-pointer">
                <a [routerLink]="['/']" class="d-flex"><img src="{{defaultImagePath}}logo.png" alt="logo-img" /></a>
              </div>
            </div>

            <nav id="megaMenuWrapper">
              <ul class="mega-menu d-flex flex-column flex-lg-row">
                @for (header of menus; track $index) {
                @if(!header?.submenu?.length){
                <li class="manin-item-list">
                  <a class="mega-main-title" [routerLink]="[header?.path]">{{
                    header?.title | titlecase
                    }}</a>
                </li>
                } @if(header?.submenu?.length){
                <li class="manin-item-list with-submenu" (mouseenter)="resetScrollPosition(header, $event)">
                  <a class="mega-main-title" href="javascript:void(0);">{{
                    header?.title | titlecase
                    }}</a>
                  <div class="main-sub-menu {{ (header?.title).replace(' ', '') }}" id="mainSubMenu"
                    [style.left]="submenuLeft" [style.right]="submenuRight">
                    <div class="tab-link-list">
                      <ul class="pb-3">
                        @for (menu of header?.submenu; track menu.id;let menuInd
                        = $index) {
                        <li id="tabList-{{ menuInd }}" [ngClass]="{
                            'active-menu-item':
                              (menuInd === 0 && !hovered) || menu.isShowContent
                          }" class="tablinks" (mouseenter)="addClassOnHover(menu); hovered = true">
                          <a href="javascript:void(0);" class="d-flex align-items-center" (click)="
                              header?.title !== 'Products'
                                ? onPlanSelect(menu)
                                : onProductSelect(menu?.path)
                            ">
                            <img [src]="menuIcon + menu?.id + '/' + menu?.image" class="plan-icon" alt=""
                              onerror="this.src='assets/images/default_logo.png'" />
                            <span> {{ menu?.title | titlecase }}</span>
                          </a>
                        </li>
                        }
                      </ul>
                    </div>
                    <div class="tab-content-list">
                      @for (menu of header?.submenu; track menu.id;let menuInd =
                      $index) {
                      <div id="tab_{{ menuInd }}" class="tabcontent" [ngClass]="{
                          'active-menu-content':
                            (menuInd === 0 && !hovered) || menu.isShowContent
                        }">
                        @if(menu?.title!=='Products'&& menu?.multiple_pet_type){
                        <span class="d-block inner-title">
                          {{ menu?.title | titlecase }}
                        </span>
                        <div class="d-flex flex-wrap mt-2">
                          @for (subItem of menu?.submenu; track $index) {
                          <span class="w-50">
                            <span class="inner-link d-inline-flex" (click)="onPlanSelect(menu, subItem.slug)">
                              {{ subItem?.title | titlecase }}
                            </span>
                          </span>
                          }
                        </div>
                        } @else { @if(menu?.submenu?.length && header?.title
                        =='Products'){
                        <span class="d-block inner-title">
                          {{ menu?.title | titlecase }}
                        </span>
                        <div class="d-flex flex-wrap mt-2">
                          @for (subItem of menu?.submenu; track $index) {
                          <span class="w-50">
                            <span class="inner-link d-inline-flex" (click)="onProductSelect(subItem.path)">
                              {{ subItem?.title | titlecase }}
                            </span>
                          </span>
                          }
                        </div>
                        } @else {
                        <div>
                          <span class="d-block inner-title">
                            {{ menu?.title | titlecase }}
                          </span>
                          <span [innerHTML]="menu?.description"></span>
                        </div>
                        } }
                      </div>
                      }
                    </div>
                  </div>
                </li>
                } }
              </ul>
            </nav>
            @if (isMenuOpen) {
            <div class="nav-mobile-menu d-lg-none">
              <mat-accordion class="accordian-position">
                @for (header of menus; track $index) {
                @if (!header?.submenu?.length) {
                <mat-expansion-panel class=" p-10" hideToggle [expanded]="false">
                  <mat-expansion-panel-header class="main-header-menu">
                    <mat-panel-title (click)="onMenuItemClick(header.path)">
                      {{header?.title}}
                    </mat-panel-title>
                  </mat-expansion-panel-header>
                </mat-expansion-panel>
                }
                @if (header?.submenu?.length) {
                <mat-expansion-panel class="p-10">
                  <mat-expansion-panel-header class="main-header-menu">
                    <mat-panel-title>
                      {{header?.title}}
                    </mat-panel-title>
                  </mat-expansion-panel-header>
                  <mat-accordion>
                    @for (plan of header?.submenu; track $index) {
                    @if (header?.title!=='Products') {
                    @if (plan.multiple_pet_type) {
                    <mat-expansion-panel (click)="openExpansionPanel(plan)" class="level-2"
                      [ngClass]="{'mat-expansion-panel-open': plan.isExpansionOpen}">
                      <mat-expansion-panel-header class="expansion-header-style">
                        <mat-panel-title>
                          <img [src]="menuIcon + plan?.id + '/' + plan?.image" class="plan-icon-width" alt=""
                            onerror="this.src='assets/images/default_logo.png'" />
                          {{ plan.title | titlecase }}
                        </mat-panel-title>
                      </mat-expansion-panel-header>

                      <div class="row m-0">
                        @for (submenu of plan.submenu; track $index) {
                        <div class="col-6">
                          <span class="plan-content d-inline-flex"
                            (click)="onMenuItemClick(plan.path + '/' + submenu.slug)">
                            {{ submenu.title | titlecase }}
                          </span>
                        </div>
                        }
                      </div>
                    </mat-expansion-panel>
                    }@else {
                    <mat-expansion-panel hideToggle [expanded]="false">
                      <mat-expansion-panel-header class="expansion-header-style">
                        <mat-panel-title (click)="onMenuItemClick(plan.path)">
                          <img [src]="menuIcon + plan?.id + '/' + plan?.image" class="plan-icon-width" alt=""
                            onerror="this.src='assets/images/default_logo.png'" />
                          {{plan?.title}}
                        </mat-panel-title>
                      </mat-expansion-panel-header>
                    </mat-expansion-panel>
                    }

                    }
                    @if (header?.title=='Products') {
                    @if (plan?.submenu?.length) {
                    <mat-expansion-panel (click)="openExpansionPanel(plan)"
                      [ngClass]="{'mat-expansion-panel-open': plan.isExpansionOpen}">
                      <mat-expansion-panel-header class="expansion-header-style">
                        <mat-panel-title>
                          <img [src]="menuIcon + plan?.id + '/' + plan?.image" class="plan-icon-width" alt=""
                            onerror="this.src='assets/images/default_logo.png'" />
                          <span (click)="onMenuItemClick('/product/list/' + plan.path)">
                            {{ plan.title | titlecase }}
                          </span>
                        </mat-panel-title>
                      </mat-expansion-panel-header>

                      <div class="row m-0 pb-2">
                        @for (submenu of plan.submenu; track $index) {
                        <div class="col-6">
                          <span class="plan-content d-inline-flex"
                            (click)="onMenuItemClick('/product/list/' + submenu.path)">
                            {{ submenu.title | titlecase }}
                          </span>
                        </div>
                        }
                      </div>
                    </mat-expansion-panel>
                    }@else{
                    <mat-expansion-panel hideToggle [expanded]="false">
                      <mat-expansion-panel-header class="expansion-header-style">
                        <mat-panel-title>
                          <img [src]="menuIcon + plan?.id + '/' + plan?.image" class="product-img-width" alt=""
                            onerror="this.src='assets/images/default_logo.png'" />
                          <span (click)="onMenuItemClick('/product/list/' + plan.path)">
                            {{ plan.title | titlecase }}
                          </span>
                        </mat-panel-title>

                      </mat-expansion-panel-header>
                    </mat-expansion-panel>
                    }

                    }
                    }
                  </mat-accordion>
                </mat-expansion-panel>
                }
                }
              </mat-accordion>
            </div> }
            <div class="d-flex align-items-end">
              <ul class="account-list d-flex d-md-none align-items-center me-3"
                [ngClass]="{ 'no-login': !loginService.userData.length }">
                @if(loginService.userData.length){
                <li>
                  <div ngbDropdown class="">
                    <button type="button" class="d-flex btn profile-btn align-items-center p-0" id="dropdownBasic1"
                      ngbDropdownToggle>
                      <span class="profile-img rounded-circle overflow-hidden" [ngClass]="{
                          'with-text': !loginService.userData[0].avatar
                        }">
                        @if (loginService.userData[0].avatar) {
                        <ngx-avatars src="{{imgPrefixLink}}/user/avatar/{{ loginService.userData[0].avatar }}"
                          (click)="openDropdownMenu()">
                        </ngx-avatars>
                        }@else {
                        <ngx-avatars bgColor="{{ avatar_bg_color }}" fgColor="{{ avatar_fg_color }}"
                          name="{{ loginService.userData[0].full_name }}" textSizeRatio="2"
                          (click)="openDropdownMenu()">
                        </ngx-avatars>
                        }
                      </span>
                    </button>
                    <div ngbDropdownMenu aria-labelledby="dropdownBasic1">
                      <ul>
                        @for (item of menuItems; track $index) {
                        <li>
                          <button ngbDropdownItem (click)="goToPage(item?.route)" class="d-flex align-items-center">
                            <div class="img-box d-flex align-items-center justify-content-center rounded-circle me-3">
                              <img [src]="item?.icon" />
                            </div>

                            <span>
                              {{ item?.title }}
                            </span>
                            <i class="fa-solid fa-arrow-right"></i>
                          </button>
                        </li>
                        } @if (switchDetails.switch_back == '' && userData[0]?.type !=
                        'backend') {
                        <li>
                          <button (click)="logout()" ngbDropdownItem class="d-flex align-items-center">
                            <div class="img-box d-flex align-items-center justify-content-center rounded-circle me-3">
                              <img [src]="'assets/images/icon/logout.svg'" />
                            </div>
                            <span class="menu-text"> Logout </span>
                            <i class="fa-solid fa-arrow-right"></i>
                          </button>
                        </li>
                        } @if (switchDetails.switch_back != '') {

                        <li>
                          <button (click)="backToDashboard()" ngbDropdownItem class="d-flex align-items-center">
                            <div class="img-box d-flex align-items-center justify-content-center rounded-circle me-3">
                              <img [src]="'assets/images/icon/back-admin.svg'" />
                            </div>
                            <span class="menu-text"> Back to Admin </span>
                            <i class="fa-solid fa-arrow-right"></i>
                          </button>
                        </li>
                        }
                      </ul>
                    </div>
                  </div>
                </li>
                }
              </ul>
              <div class="cart dropdown" ngbDropdown #cartModel="ngbDropdown" [autoClose]="'outside'">
                <button type="button" class="btn position-relative dropdown-toggle" ngbDropdownToggle
                  (click)="onCartMenuClick()">
                  <img [src]="'assets/images/header/shopping-bag.svg'" alt="" />
                  <span class="position-absolute top-0 start-100 translate-middle badge rounded-pill bg-success">{{
                    cartCount }}</span>
                </button>
                <div class="cart-list dropdown-menu" ngbDropdownMenu aria-labelledby="dropdownBasic2"
                  [ngClass]="{'d-none': !cartDetails?.items?.length}">
                  @if (cartCount > 0) {
                  <div class="pb-2">
                    <div class="title-box">You have {{ cartDetails?.items?.length }} Item in Cart</div>
                  </div>
                  }
                  @if(cartCount == 0){
                  Your cart is empty!
                  }
                  <ul class="cart-product-list">
                    @for (data of cartDetails?.items; track $index;let last=$last) {
                    <li class="my-3 px-0" ngbDropdownItem>
                      <div class="d-flex mb-3">
                        <div class="img-box me-3">
                          @switch (data?.item_type) {
                          @case ('subscription') {
                          <img [src]="filePath +  data?.plan?.id + '/cover_image/' +data?.plan?.cover_image"
                            alt="plan-img" [width]="80" onerror="this.src='assets/images/default_subscription.png'">
                          }
                          @case ('product') {
                          <img [src]="productImagePath +data?.product_id + '/' +data?.image" alt="product-img"
                            [width]="80" onerror="this.src='assets/images/default_product.png'">
                          }
                          @case ('boarding') {
                          <img [src]=" boardingFilePath + data?.cage_type_id + '/cover_image/' +data?.image"
                            alt="Cage-img" [width]="80" onerror="this.src='assets/images/default_cage.png'">
                          }
                          @case ('grooming') {
                          <img [src]="'assets/images/default_grooming.png'" alt="Cage-img" [width]="80">
                          }
                          }
                        </div>

                        <div class="content-box">
                          @if (data?.item_type == 'subscription') {
                          <span class="text-primary text-wrap">{{ data?.plan_level?.title }}</span>
                          <p class="text-default text-wrap mb-0">{{ data?.plan?.name }} for
                            <span class="text-name text-wrap">{{
                              data?.pet_info?.name
                              }}
                            </span>
                          </p>
                          @if (data?.extra_services?.length > 0) {
                          <p class="text-wrap text-default mb-0">
                            Including
                            <span class="text-name text-wrap">{{ data?.extra_services?.length }} Extra
                              Services</span>
                          </p>
                          }
                          }
                          @if (data?.item_type == 'product') {
                          <span class="text-primary text-wrap">{{ data?.title | titlecase }}</span>
                          <p class="text-default text-wrap mb-0">
                            Quantity:<span>
                              {{data?.quantity}}
                            </span>
                          </p>
                          }
                          @if (data?.item_type=='boarding') {
                          <span class="text-primary text-wrap">{{ data?.title }}</span>
                          <p class="text-default text-wrap mb-0">Booked For,</p>
                          @for (pet of data?.pet_price_detail; track $index) {
                          <p class="text-default text-wrap mb-0">
                            Pet
                            <span>
                              <b>
                                {{ pet?.name | titlecase}}
                              </b>
                            </span>

                            with
                            <span>
                              <b>
                                {{pet.addon?.length }}
                              </b>
                            </span>
                            add-ons.
                          </p>
                          }
                          <p class="text-default text-wrap mb-0">
                            Booking from&nbsp;
                            <span>
                              <b>
                                {{
                                data?.booking_from | date : format
                                }}
                              </b>
                            </span>
                            <span>
                              <b>&nbsp; to&nbsp;</b> </span>
                            <span>
                              <b>
                                {{
                                data?.booking_to | date : format
                                }}.
                              </b>
                            </span>
                          </p>
                          @if (data?.is_advance_booking_amount) {
                          <p class="text-default text-wrap mb-0">
                            Advanced Payment
                            <span>{{
                              data?.advance_payment | currency
                              }}</span>
                          </p>
                          }
                          }
                          @if (data?.item_type=='grooming') {
                          <span class="text-primary text-wrap">{{ data?.plan_detail?.name | titlecase }}</span>
                          @if (data?.addon_detail?.length > 0) {
                          <p class="text-default text-wrap mb-0">
                            Including
                            <span>{{ data?.addon_detail?.length }} Extra
                              Services</span>
                          </p>
                          }
                          @if (data?.discount) {
                          <p class="text-default text-wrap mb-0">
                            Given Discount of
                            <span>{{
                              data?.discount | currency
                              }}</span>
                          </p>
                          }
                          @if (data?.is_advance_grooming_amount) {
                          <p class="text-default text-wrap mb-0">
                            Advanced Payment
                            <span>{{
                              data?.advance_payment | currency
                              }}</span>
                          </p>
                          }
                          }
                        </div>
                      </div>

                      @if (data?.item_type == 'subscription') {

                      <div class="d-flex justify-content-between align-items-center">
                        <p class="m-0 text-info">Price:{{ data?.cart_price | currency }}</p>
                        <div class="d-flex justify-content-end btn-box">
                          <a ngbTooltip="Edit" (click)="
                              editCartItem(
                                data,
                                cartModel,
                                'subscription'
                              )
                            " class="d-inline-flex cursor-pointer"><img [src]="'assets/images/header/cart/edit.svg'"
                              alt=""></a>
                          <a (click)="removeCartItem(data.id)" ngbTooltip="Remove" class="d-inline-flex cursor-pointer">
                            <img [src]="'assets/images/header/cart/delete.svg'" alt=""></a>
                        </div>
                      </div>
                      @if (data?.error_message)
                      {
                      <span class="text-danger d-block text-center">{{ data?.error_message }}</span>
                      }
                      }

                      @if (data?.item_type == 'product') {
                      <div class="d-flex justify-content-between align-items-center">
                        <p class="m-0 text-info">Price:{{ data?.price | currency }}</p>
                        <div class="d-flex justify-content-end btn-box">
                          <a ngbTooltip="Remove" (click)="removeCartItem(data.id)" class="d-inline-flex cursor-pointer">
                            <img [src]="'assets/images/header/cart/delete.svg'" alt=""></a>
                        </div>
                      </div>
                      @if (data?.error_message) {
                      <span class="text-danger d-block text-center">{{ data?.error_message }}</span>
                      }
                      }
                      @if (data?.item_type == 'grooming') {
                      <div class="d-flex justify-content-between align-items-center">
                        <p class="m-0 text-info">Payable Amount:{{ data?.advance_payment | currency }}</p>
                        <div class="d-flex justify-content-end btn-box">
                          <a ngbTooltip="Edit" (click)="editCartItem(data,cartModel,'grooming')"
                            class="d-inline-flex cursor-pointer">
                            <img [src]="'assets/images/header/cart/edit.svg'" alt=""></a>
                          <a ngbTooltip="Remove" (click)="removeCartItem(data.id)" class="d-inline-flex cursor-pointer">
                            <img [src]="'assets/images/header/cart/delete.svg'" alt=""></a>
                        </div>
                      </div>
                      @if (data?.error_message) {
                      <span class="text-danger d-block text-center">{{ data?.error_message }}</span>
                      }
                      }

                      @if (data?.item_type == 'boarding') {
                      <div class="d-flex justify-content-between align-items-center">
                        <p class="m-0 text-info">Payable Amount{{ data?.advance_payment | currency }}</p>
                        <div class="d-flex justify-content-end btn-box">
                          <a ngbTooltip="Edit" (click)="editCartItem( data, cartModel,'boarding')"
                            class="d-inline-flex cursor-pointer">
                            <img [src]="'assets/images/header/cart/edit.svg'" alt="">
                          </a>
                          <a ngbTooltip="Remove" (click)="removeCartItem(data.id)" class="d-inline-flex cursor-pointer">
                            <img [src]="'assets/images/header/cart/delete.svg'" alt="">
                          </a>
                        </div>
                      </div>
                      @if (data?.error_message) {
                      <span class="text-danger d-block text-center">{{ data?.error_message }}</span>
                      }
                      }
                    </li>
                    }
                  </ul>
                  <div>
                    <div class="bg-default rounded-3 p-2 text-center my-3 text-white">
                      <h6 class="my-2">Total: {{ cartDetails?.cart_payable_price | currency }}</h6>
                    </div>
                    <button class="btn btn-success w-100" (click)="CheckUserAuthentication(cartModel)"
                      [disabled]="cartCount == 0">Proceed to checkout</button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</header>

<!-- Edit Grooming Plan Modal -->

@if(activeEditGroomingModal){
<app-grooming-plan-modal [petDetails]="groomingPetDetail" [planDetails]="groomingPlanDetail"
  [showGroomingPlanModal]="showModal" (closeGroomingPlanModal)="closeGroomingPlanModal($event)">
</app-grooming-plan-modal>
} @if(activeEditBoardingModal){
<app-cage-booking-modal [bookingPetDetails]="boardingPetDetail" [planDetails]="boardingPlanDetail"
  [showPlanModal]="showBoardingModal" (closePlanModal)="closeBoardingPlanModal($event)">
</app-cage-booking-modal>
}

<div class="modal outpost-modal custom-modal" id="outpostModal" tabindex="-1" role="dialog"
  aria-labelledby="myExtraLargeModalLabel" aria-hidden="true" data-backdrop="static" data-keyboard="false">
  <div class="modal-dialog modal-dialog-scrollable modal-dialog-centered modal-xl zoomIn animated" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="text-info" id="exampleModalLongTitle">
          Select your nearest Center
          <i class="fa-solid fa-crosshairs-simple"></i>
        </h5>
        <button type="button" class="close btn-close" data-dismiss="modal" aria-label="Close"
          (click)="closeModal()"></button>
      </div>
      <div class="modal-body main-modal">
        <div class="row mb-4 align-items-end justify-content-center justify-content-lg-start">
          <div class="col-xl-6 col-lg-6">
            <label></label>
            <input placeholder="Enter Address to find nearest Center" type="text" class="form-control detect-loc"
              #search (keyup)="onKey($event)" (keydown.Tab)="onKeyTab($event)" />
          </div>

          <div class="col-lg-1 col-md-1 col-sm-2 col-xs-1 text-center mb-2">
            <span><b>OR</b></span>
          </div>

          <div class="col-xl-4 col-lg-5 mt-3 mt-lg-0">
            <button class="btn detect-loc-btn mx-lg-0 mx-auto" (click)="getCurrentlocation()">
              <img [src]="'assets/images/header/crosshair.svg'" alt="" class="me-2" />
              Get Current Location
            </button>
          </div>
        </div>

        <app-block-spinner [name]="'isSpinner'" [isSpinnerShow]="isSpinner"></app-block-spinner>

        @if(!isSpinner && outpostList.length > 0){
        <div class="row">
          @for (outpost of outpostList; track $index) {
          <div class="col-12 col-lg-6 cursor-pointer d-flex" (click)="selectCenter(outpost)">
            <div class="loc-box mb-4 w-100">
              <h6 class="text-primary">
                <span class="">{{ outpost?.title }}</span>
                - @if(outpost?.distance){
                <span>{{ outpost?.distance }} mi</span>
                }
              </h6>
              <div class="d-flex justify-content-between my-3 flex-column flex-md-row">
                @if(outpost?.mobile_no){
                <div>
                  <div class="sub-title">Phone Number</div>
                  <span>{{ outpost?.mobile_no }}</span>
                </div>
                } @if(outpost?.timing){
                <div class="mt-3 mt-md-0">
                  <div class="sub-title">Time</div>
                  <span>{{ outpost?.timing }}</span>
                </div>
                }
              </div>
              <div>
                <div class="sub-title">Address</div>
                <span>{{ outpost?.address }}</span>
              </div>
              <div class="mt-3" (click)="$event.stopPropagation()">
                <a class="d-flex justify-content-between align-items-center map-btn">
                  <span class="text-uppercase">View MAp</span>
                  <i class="fa-solid fa-arrow-right" (click)="utils.getLatLongFromAddress(outpost?.address)"></i>
                </a>
              </div>
            </div>
          </div>
          }
        </div>
        } @if(!isSpinner && !outpostList.length){
        <div class="text-center m-t-20 m-b-20">
          <span>No Records to Show!</span>
        </div>
        }
      </div>
    </div>
  </div>
</div>